import { LoginBonusKind } from '../../../../../services/exports/Constants';

export default {
  [LoginBonusKind.MobileAppSignupBonus]: {
    toast: 'Gratulacje! Naliczono {{amount}} cashbacku.',
  },
};
